import '../../Style/product/fill-form.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CusIconLabel from "../../Components/custom-icon-label/Cus_Icon_Label.js";
import CustomButton from "../../Components/custom-button/CustomButton.js";
import { t } from "i18next";
import {  paymenttransfer } from "../../Services/api-service.js";
function FillFormSection({objectDto, setObjectDto}){
    const handleButtonClick = () => {
        var db = {...objectDto, ...{
            "id":2,
            "productId": 2,
            "paymentStatus": 0,
            "confirm": 0,
            "status": 0,
            "fullName": "Nguyễn Văn Test",
            "dob": "2002-11-11",
            "gender": 0,
            "phoneNumber": "0393939393",
            "email": "a@gmail.com",
            "kycStatus": 0,
            "productName": "Nâng Cao",
            "description": "Phú Bảo An Gia 2.0",
            "productCode": "EC05",
            "age": "22",
            "sumAssured": 200000000,
            "maleRate": 1.26,
            "femaleRate": 1.13,
            "discountRate": 20,
            "policyTerm": "01",
            "frequency": "01",
            "strSumAssured": "200.000.000 đồng",
            "premium": "202000.000000000",
            "premiumFemale": "181000.000000000",
            "clientFlag": 0,
            "step": 3,
            "sendVerifyMail": 0,
            "productList": [
                {
                "productId": 1,
                "paymentStatus": 0,
                "confirm": 0,
                "status": 0,
                "gender": 0,
                "kycStatus": 0,
                "productName": "Cơ Bản",
                "description": "Phú Bảo An Gia 2.0",
                "productCode": "EC05",
                "sumAssured": 100000000,
                "maleRate": 1.26,
                "femaleRate": 1.13,
                "discountRate": 20,
                "policyTerm": "01",
                "frequency": "01",
                "strSumAssured": "100.000.000 đồng",
                "premiumMale": "101000.000000000",
                "premiumFemale": "91000.000000000",
                "clientFlag": 0,
                "step": 0,
                "sendVerifyMail": 0
                },
                {
                "productId": 2,
                "paymentStatus": 0,
                "confirm": 0,
                "status": 0,
                "gender": 0,
                "kycStatus": 0,
                "productName": "Nâng Cao",
                "description": "Phú Bảo An Gia 2.0",
                "productCode": "EC05",
                "sumAssured": 200000000,
                "maleRate": 1.26,
                "femaleRate": 1.13,
                "discountRate": 20,
                "policyTerm": "01",
                "frequency": "01",
                "strSumAssured": "200.000.000 đồng",
                "premiumMale": "202000.000000000",
                "premiumFemale": "181000.000000000",
                "clientFlag": 0,
                "step": 0,
                "sendVerifyMail": 0
                },
                {
                "productId": 3,
                "paymentStatus": 0,
                "confirm": 0,
                "status": 0,
                "gender": 0,
                "kycStatus": 0,
                "productName": "Ưu Việt",
                "description": "Phú Bảo An Gia 2.0",
                "productCode": "EC05",
                "sumAssured": 400000000,
                "maleRate": 1.26,
                "femaleRate": 1.13,
                "discountRate": 20,
                "policyTerm": "01",
                "frequency": "01",
                "strSumAssured": "400.000.000 đồng",
                "premiumMale": "404000.000000000",
                "premiumFemale": "362000.000000000",
                "clientFlag": 0,
                "step": 0,
                "sendVerifyMail": 0
                }
            ],
            "provinceCode": "24",
            "districtCode": "216",
            "contactProvinceCode": "24",
            "contactDistrictCode": "220",
            "contactWardCode": "07660",
            "wardCode": "07348",
            "birthPlace": "04",
            "married": "0",
            "occupationCode": "1Z01",
            "idnumber": "3324234234",
            "iddate": "2025-03-31",
            "idplace": "04",
            "address": "999 HTP",
            "contactAddress": "1111 HTP",
            "applicationNo": "3xxxxxxx"
            }};
            paymenttransfer(db);
    }
    return (
        <section className="fill-form">
            <div className="container-card-fill-form">
                <div className="home-fill-form-wrapper">
                    <div className="fill-form-form">
                        <div className="title-fill-form-wrap">
                            <h2 className="title-font-fill-form home-title-product">TEST PAYMENT</h2>
                        </div>
                    </div>
                    <div className="fill-form-fill">
                        <div className="form-input-fill-form cus-button">
                            <CustomButton title={"Test"} onClick={handleButtonClick}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>    
    );
}
export default FillFormSection;